import Overview from "@/components/admin/Content/WebPages/ProgrammesAndInitiatives/Programmes/Overview";
import HeroSection from "@/components/admin/Content/WebPages/ProgrammesAndInitiatives/Programmes/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const Programmes = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.PROGRAMME_BANNER ?? {
        sectionTag: 'PROGRAMME_BANNER',
        contentType: 'WITH_FILE',
        title: 'Programmes Banner',
        description: 'Banner for the programmes page'
      }} />
      <Overview data={pageData?.PROGRAMMES ?? {
        sectionTag: 'PROGRAMMES',
        contentType: 'WITHOUT_FILE',
        sectionTitle: 'Programmes',
        title: 'Our Programmes'
      }} />
    </div>
  )
}

export default Programmes